import script from "./MediaflowSourceRow.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowSourceRow.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowSourceRow.vue?vue&type=style&index=0&id=583964f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583964f4"]])

export default __exports__